import React from 'react';
import Card from '../cards/Card';
import { PHASES } from '../../utils/gameRules';

function PlayerHand({ hand, onCardClick, selectedPosition, gamePhase, revealMode, revealedPositions = [] }) {
  if (!hand || hand.length === 0) return null;

  const topRow = hand.slice(0, 3);
  const bottomRow = hand.slice(3, 6);

  const handleClick = (position) => {
    if (onCardClick) {
      onCardClick(position);
    }
  };

  const isClickable = (card, position) => {
    if (revealMode) return !card.faceUp && !revealedPositions.includes(position);
    if (gamePhase === PHASES.PLAYING) return true;
    return false;
  };

  const isFaceUp = (card, position) => {
    return card.faceUp || revealedPositions.includes(position);
  };

  return (
    <div className="player-hand">
      <div className="player-hand__row">
        {topRow.map((card, i) => (
          <Card
            key={i}
            card={card}
            faceUp={isFaceUp(card, i)}
            selected={selectedPosition === i}
            onClick={() => handleClick(i)}
            disabled={!isClickable(card, i)}
          />
        ))}
      </div>
      <div className="player-hand__row">
        {bottomRow.map((card, i) => (
          <Card
            key={i + 3}
            card={card}
            faceUp={isFaceUp(card, i + 3)}
            selected={selectedPosition === i + 3}
            onClick={() => handleClick(i + 3)}
            disabled={!isClickable(card, i + 3)}
          />
        ))}
      </div>
    </div>
  );
}

export default PlayerHand;
